import {
    getField,
    updateField
} from "vuex-map-fields";
import db from "@/firebase/firebaseInit";

const state = {
    latestNews: [],
    allNews: [],
    fakeNews: [],
    currentTab: 0
};

const actions = {
    currentNewsTab({
        commit
    }, {
        tab
    }) {
        commit("updateField", {
            path: "currentTab",
            value: tab,
        })
    },
    async fetchLatestNews({
        commit
    }) {
        await db.collection('/news/en/all_news').limit(1).orderBy('date', 'desc').get().then(
            (snapshot) => {
                var latestNews = [];
                snapshot.forEach(doc => {
                    latestNews.push(doc.data());
                });
                commit("updateField", {
                    path: "latestNews",
                    value: latestNews,
                })
            });
        
        await db.collection('/news/am/all_news').limit(1).orderBy('date', 'desc').get().then(
            (snapshot) => {
                var latestNews = [];
                snapshot.forEach(doc => {
                    latestNews.push(doc.data());
                });
                commit("updateField", {
                    path: "latestNews",
                    value: latestNews,
                })
            });
        
        await db.collection('/news/ar/all_news').limit(1).orderBy('date', 'desc').get().then(
            (snapshot) => {
                var latestNews = [];
                snapshot.forEach(doc => {
                    latestNews.push(doc.data());
                });
                commit("updateField", {
                    path: "latestNews",
                    value: latestNews,
                })
            });
    },
    async fetchLatestNewsOR({
        commit
    }) {
        await db.collection('/news/or/all_news').limit(3).orderBy('date', 'desc').get().then(
            (snapshot) => {
                var latestNews = [];
                snapshot.forEach(doc => {
                    latestNews.push(doc.data());
                });
                commit("updateField", {
                    path: "latestNews",
                    value: latestNews,
                })
            });
        
    },

    async fetchAllNews({
        commit
    }, payload) {
        await db.collection(`/news/${payload}/all_news/`).orderBy('date', 'desc').get().then(
            (snapshot) => {
                var allNews = [];
                snapshot.forEach(doc => {
                    allNews.push({
                        id: doc.id,
                        content: doc.data()
                    });
                });
                commit("updateField", {
                    path: "allNews",
                    value: allNews,
                })
            });


    },

    async fetchFakeNews({
        commit
    }, payload) {

        await db.collection(`/news/${payload}/fake_news`).orderBy('date', 'desc').get().then(
            (snapshot) => {
                var fakeNews = [];
                snapshot.forEach(doc => {
                    fakeNews.push({
                        id: doc.id,
                        content: doc.data()
                    });
                });
                commit("updateField", {
                    path: "fakeNews",
                    value: fakeNews,
                })
            });
    },

    async addNews({
        commit
    }, {
        payload,
        payloadType
    }) {
        if (payloadType.type === "Verified News") {
            await db.collection(`/news/${payload.lang}/all_news`).add({
                title: payload.news.title,
                date: payload.news.date,
                body: payload.news.body,
                source: payload.news.source,
                image: payload.news.image,
                likes: payload.news.likes,
                views: payload.news.views,
            });
        }

        // for fake News

        if (payloadType.type === "Fake News") {
            await db.collection(`/news/${payload.lang}/fake_news`).add({
                title: payload.news.title,
                date: payload.news.date,
                body: payload.news.body,
                source: payload.news.source,
                image: payload.news.image,
                likes: payload.news.likes,
                views: payload.news.views,
            });
        }

    },

    async updateNews({
        commit
    }, {
        payload,
        payloadPath,
        payloadId
    }) {

        // Use a reference path for verified/fake  Doc to edit specific one. 
        await db.collection(`/news/${payload.lang}/` + payloadPath).doc(payloadId).update({
            title: payload.news.title,
            date: payload.news.date,
            body: payload.news.body,
            source: payload.news.source,
            image: payload.news.image,
            likes: payload.news.likes,
            views: payload.news.views,
        });
    },

    async deleteNews({}, {
        payloadPath,
        payloadId,
        lang
    }) {

        // Use a reference path for verified/fake  Doc to DELETE specific one. 
        await db.collection(`/news/${lang}/` + payloadPath).doc(payloadId).delete();
    },
};

const mutations = {
    updateField,
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
